import {Mutation, Action, VuexModule, getModule, Module} from 'vuex-module-decorators'
import store from '../store'
import {AxiosResponse} from "axios";

export namespace ApiLogsStore {
    export interface Log {
        url: string,
        date: Date,
        response: AxiosResponse<any>
    }
}

@Module({
    name: "ApiLogsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ApiLogsStore extends VuexModule {
    // state
    private logs: ApiLogsStore.Log[] = [];

    // getter
    get all() {
        return this.logs || []
    }

    get errors(): ApiLogsStore.Log[] {
        return this.all.filter(v => {
            // todo １０秒以内に発生したエラーを全部返すような条件に
            return v.response.status != 200
        });
    }

    @Mutation
    public add(response: AxiosResponse<any>) {
        const url = response.config.url || "";
        this.logs.push({
            url: url,
            response: response,
            date: new Date(),
        })
    }
}

export default getModule(ApiLogsStore)
